const generateReceiptContent = (receiptData) => {
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Collection Receipt</title>
          <style>
            body {
                font-family: Arial, sans-serif;
                line-height: 1.4;
                color: #333;
                background: white;
                padding: 20px;
                margin: 0;
                font-size: 14px;
            }
            .container {
                max-width: 800px;
                margin: 0 auto;
                padding: 20px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0,0,0,0.05);
            }
            .receipt-header {
                text-align: center;
                margin-bottom: 30px;
            }
            .company-logo {
                text-align: center;
                margin-bottom: 15px;
            }
            .company-logo img {
                max-width: 120px;
                max-height: 120px;
            }
            /* Force image to display even in PDF */
            .company-logo-alt {
                text-align: center;
                font-size: 28px;
                font-weight: bold;
                margin-bottom: 10px;
                color: #333;
            }
            .company-name {
                font-size: 24px;
                font-weight: bold;
                margin: 0;
                color: #333;
            }
            .company-subheading {
                font-size: 18px;
                font-weight: bold;
                margin: 5px 0 15px 0;
                color: #333;
            }
            .company-details {
                margin-bottom: 10px;
                font-size: 14px;
            }
            .company-details p {
                margin: 5px 0;
            }
            .divider {
                height: 2px;
                background-color: #000;
                margin: 20px 0;
                width: 100%;
            }
            .receipt-title {
                text-align: center;
                font-size: 22px;
                font-weight: bold;
                margin: 30px 0;
                letter-spacing: 1px;
            }
            .receipt-info {
                margin-bottom: 25px;
                font-size: 15px;
            }
            .customer-details {
                margin: 30px 0;
                padding: 15px;
                background-color: #f9f9f9;
                border-radius: 4px;
            }
            .customer-details h3 {
                font-size: 16px;
                margin-bottom: 10px;
                font-weight: bold;
            }
            .customer-details p {
                margin: 5px 0;
            }
            .receipt-table {
                width: 100%;
                border-collapse: collapse;
                margin: 25px 0 60px 0; /* Increased bottom margin */
            }
            .receipt-table th {
                background-color: #f2f2f2;
                border: 1px solid #ddd;
                padding: 12px;
                text-align: left;
                font-weight: bold;
            }
            .receipt-table td {
                border: 1px solid #ddd;
                padding: 12px;
                text-align: left;
            }
            .signature-section {
                margin-top: 20px; /* Increased top margin */
                display: flex;
                justify-content: space-between;
            }
            .signature-box {
                border-top: 1px solid #000;
                width: 35%; /* Reduced width for more separation */
                text-align: center;
                padding-top: 10px;
                font-weight: 500;
                margin-bottom: 20px; /* Added bottom margin */
            }
            .receipt-footer {
                text-align: center;
                margin-top: 20px; /* Increased margin */
                font-size: 12px;
                color: #555;
                font-style: italic;
                padding: 10px 0;
                border-top: 1px solid #eee;
            }

            @media print {
                @page {
                    margin: 15mm;
                }
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .receipt-table th {
                    background-color: #f2f2f2 !important;
                }
                .container {
                    border: none;
                    box-shadow: none;
                    padding: 0;
                }
                /* Ensure images display in PDF */
                img {
                    display: block !important;
                    max-width: 100%;
                }
                /* For fallback if image doesn't load */
                .company-logo-fallback {
                    display: block;
                }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="receipt-header">
              <!-- Logo with fallback -->
              <div class="company-logo">
                <img src="/images/logo.png" alt="W. THOMAS & SONS" onerror="this.style.display='none'; document.getElementById('logo-fallback').style.display='block';">
                <div id="logo-fallback" class="company-logo-alt" style="display:none;">WTS</div>
              </div>
              <h1 class="company-name">W. THOMAS & SONS</h1>
              <h2 class="company-subheading">GUN CARE CENTRE</h2>
              <div class="company-details">
                <p>Dambulugama, Anuradhapura Road, Dambulla</p>
                <p>Tel: 0664933042</p>
                <p>Hotline: 0777 319250</p>
                <p>Fax: 011 2972608 | E-mail: wthomasandsons@gmail.com</p>
              </div>
            </div>

            <div class="divider"></div>

            <h2 class="receipt-title">COLLECTION RECEIPT</h2>
            
            <div class="receipt-info">
              <p><strong>Date:</strong> ${receiptData.date}</p>
            </div>

            <div class="customer-details">
              <h3>Customer Details:</h3>
              <p><strong>Name:</strong> ${receiptData.customerName}</p>
              <p><strong>NIC:</strong> ${receiptData.customerNIC}</p>
            </div>

            <table class="receipt-table">
              <thead>
                <tr>
                  <th width="40%">Serial Number</th>
                  <th width="60%">Issue Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${receiptData.serialNumber}</td>
                  <td>${receiptData.issueDescription}</td>
                </tr>
              </tbody>
            </table>
            
            <!-- Adding spacing element -->
            <div style="height: 40px;"></div>

            <div class="signature-section">
              <div class="signature-box">Customer Signature</div>
              <div class="signature-box">Authorized Signature</div>
            </div>

            <div class="receipt-footer">
              <p>This receipt serves as proof that the item has been collected for repair.</p>
            </div>
          </div>

          <script>
            // Script to ensure image loading or fallback in PDF
            window.onload = function() {
              const logo = document.querySelector('.company-logo img');
              if (logo) {
                logo.onerror = function() {
                  this.style.display = 'none';
                  document.getElementById('logo-fallback').style.display = 'block';
                };
                
                // Force logo to reload to trigger onerror if needed
                const src = logo.src;
                logo.src = '';
                setTimeout(() => { logo.src = src; }, 10);
              }
              
              // Add page numbers
              const pageInfo = document.createElement('div');
              pageInfo.style.position = 'fixed';
              pageInfo.style.right = '20px';
              pageInfo.style.bottom = '20px';
              pageInfo.style.fontSize = '10px';
              pageInfo.style.color = '#888';
              pageInfo.innerHTML = 'Page 1/1';
              document.body.appendChild(pageInfo);
            };
          </script>
        </body>
      </html>
    `;
};

export default generateReceiptContent;